import { render, staticRenderFns } from "./AccessTransactionLogs.vue?vue&type=template&id=3f28922e&"
import script from "./AccessTransactionLogs.vue?vue&type=script&lang=js&"
export * from "./AccessTransactionLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports